import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const DeleteAreaModal = ({ isOpen, onClose, onConfirm, area, language }) => {
  if (!isOpen || !area) return null;

  const translations = {
    en: {
      deleteArea: "Delete Area",
      confirmDelete: "Are you sure you want to delete this area?",
      areaName: "Area Name",
      cancel: "Cancel",
      delete: "Delete"
    },
    ar: {
      deleteArea: "حذف المنطقة",
      confirmDelete: "هل أنت متأكد من حذف هذه المنطقة؟",
      areaName: "اسم المنطقة",
      cancel: "إلغاء",
      delete: "حذف"
    }
  };

  const t = translations[language];

  const handleConfirm = () => {
    onConfirm(area.id);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center mb-4 gap-2">
            <div className="p-2 rounded-full bg-red-500">
              <Icon 
                name="Trash2" 
                size={24} 
                className="text-white" 
              />
            </div>
            <h3 className="ml-3 text-lg font-semibold text-gray-900">
              {t.deleteArea}
            </h3>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-3">
              {t.confirmDelete}
            </p>
            <p className="text-sm font-medium text-gray-900">
              {t.areaName}: <span className="text-red-600">{area.name}</span>
            </p>
          </div>

          {/* Actions */}
          <div className="flex space-x-3 gap-4">
            <button
              onClick={handleConfirm}
              className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
            >
              {t.delete}
            </button>
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
            >
              {t.cancel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAreaModal;